


// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"

const firebaseConfig = {
    apiKey: "AIzaSyDiBr3sLqnJVzj70g1FXPWo8nCznzsmcNc",
    authDomain: "cd-lynparza-game.firebaseapp.com",
    databaseURL: "https://cd-lynparza-game-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "cd-lynparza-game",
    storageBucket: "cd-lynparza-game.appspot.com",
    messagingSenderId: "1009249614304",
    appId: "1:1009249614304:web:400d48d3908308afb0d385",
    measurementId: "G-C7SGJ8SQ77"
};
const app = initializeApp(firebaseConfig);

// const analytics = getAnalytics(app);
export const db = getFirestore(app);

